import { createSelector, createAction } from "@reduxjs/toolkit";

// Declaring the Selectors
export const getUserSelector = (state) => {
  return state.user;
};

export const getUserDetailsSelector = createSelector(
  getUserSelector,
  (user) => user.userDetails
);

export const getUserNameSelector = createSelector(
  getUserDetailsSelector,
  (userDetails) => userDetails?.userNameFromEmail || null
);

export const getUserIdSelector = createSelector(
  getUserDetailsSelector,
  (userDetails) => userDetails?._delegate?.uid || null
);

// Declaring the Actions
export const CreateNewUserRequest = "CREATE_USER_REQUEST";
export const CreateNewUserSuccess = "CREATE_USER_SUCCESS";
export const SetUser = "SET_USER";

export const CreateNewUserRequestAction = createAction(CreateNewUserRequest);
export const CreateNewUserSuccessAction = createAction(CreateNewUserSuccess);
export const SetUserAction = createAction(SetUser);

// Decalaring the Reducers
const initialState = {
  userDetails: null,
};

const authenticationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SetUser: {
      if (!payload) return { ...state, userDetails: payload };

      const { email } = payload;
      const userNameFromEmail = email.split("@")[0];
      return { ...state, userDetails: { ...payload, userNameFromEmail } };
    }
    default:
      return state;
  }
};

export default authenticationReducer;
